<div
  id="GoToComponent" [hidden]="hiddenContainer"
  class="card esri-widget animation-on-tool-open"
  #goToComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-8" translate>
        HEADER_PANEL.GOTO
      </div>
      <div class="col-md-4">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>

  <!-- the card body -->
  <div class="card-body">
    <form [formGroup]="formGroup" class="needs-validation">
      <div class="form-group">
        <!--- coordinates -->
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text easting" translate>WIDGET.GOTO.EASTING</span>
              </div>
              <input
                #xCoordinateRef
                name="xCoordinate"
                formControlName="xCoordinate"
                type="number"
                class="form-control"
              />
              <div class="invalid-tooltip xCoordinate"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>WIDGET.GOTO.NORTHING</span>
              </div>
              <input
                #yCoordinateRef
                name="yCoordinate"
                formControlName="yCoordinate"
                type="number"
                class="form-control"
              />
              <div class="invalid-tooltip yCoordinate"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-footer">
    <!--- buttons -->
    <div class="row">
      <div class="col-md-12">
        <div class="btn-group btn-block" role="group" aria-label="Basic example">
          <button class="btn btn-sm btn-light" (click)="panTo()">
            <i class="material-icons md-18 md-btn-align">pan_tool</i>
          </button>
          <button class="btn btn-sm btn-light" (click)="goTo()">
            <i class="material-icons md-18 md-btn-align">zoom_in</i>
          </button>
          <button class="btn btn-sm btn-light" (click)="flash()">
            <i class="material-icons md-18 md-btn-align">flash_on</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
